import img1 from '../Instrumental/img1.jpg'
import img2 from '../Instrumental/img2.jpg'
import img3 from '../Instrumental/img3.jpg'
import img4 from '../Instrumental/img4.jpg'
import img5 from '../Instrumental/img5.jpg'
import img6 from '../Instrumental/img6.jpg'
import img7 from '../Instrumental/img7.jpg'
import img8 from '../Instrumental/img8.jpg'
import img9 from '../Instrumental/img9.jpg'
import img10 from '../Instrumental/img10.jpg'
import img11 from '../Instrumental/img11.jpg'
import img12 from '../Instrumental/img12.jpg'
import img13 from '../Instrumental/img13.jpg'
import img14 from '../Instrumental/img14.jpg'
import img15 from '../Instrumental/img15.jpg'
import img16 from '../Instrumental/img16.jpg'
import img17 from '../Instrumental/img17.jpg'
import { Footer } from './Footer'
import React, { Component } from 'react'
import { Row, Col, Container, Card, Accordion } from 'react-bootstrap'
import { Header } from './Header'

export class EngInstrumental extends Component {
    render() {
        return (
            <div>
                <Header />
                <Container>
                    <br />
                    <h1 className="text-center">Surgical Instruments</h1>
                    <p>
                        If you need to purchase medical equipment, ensure it meets the quality you are looking for.<br />
                        Place your order online. And remember to confirm your medicine order with us.<br />
                        Couldn't find the equipment you need? Contact us! It will be a pleasure to assist you.<br />
                        Different qualities of Stainless Steel: German, USA, Pakistani, and Chinese.
                    </p>
                    <br />

                    {/* Accordion syntax matching your Spanish version */}
                    <Accordion defaultActiveKey="0">
                        <Accordion.Item eventKey="0">
                            <Accordion.Header>Stainless Steel Instruments</Accordion.Header>
                            <Accordion.Body className="fondo-texto">
                                <Row>
                                    <Col md={6}>
                                        <ul>
                                            <li>Bedpans</li><li>Trays</li><li>Medicine Cups</li>
                                            <li>Uterine Curettes</li><li>Dilators</li><li>C-Section Kits</li>
                                            <li>Delivery Kits</li><li>Vaginal Speculums</li><li>Sterilizers</li>
                                            <li>Minor Surgery & Dissection Kits</li><li>Major and Minor Surgery Kits</li>
                                            <li>Laryngoscopes</li>
                                        </ul>
                                    </Col>
                                    <Col md={6}>
                                        <ul>
                                            <li>Reflex Hammers</li><li>Autoclaves</li><li>ENT Diagnostic Sets</li>
                                            <li>Basins</li><li>Forceps</li><li>Forceps Holders</li><li>Thermometer Holders</li>
                                            <li>Kidney Dishes</li><li>Diagnostic Sets</li><li>Tenaculums</li><li>Scissors</li><li>Urinals</li>
                                        </ul>
                                    </Col>
                                </Row>

                                {/* Image gallery matching the Spanish pattern */}
                                <Row xs={1} md={3} className="g-4 mt-3">
                                    {[
                                        { img: img2, title: "Vaginal Speculums" },
                                        { img: img3, title: "Tray with Lid" },
                                        { img: img4, title: "Forceps Holder" },
                                        { img: img5, title: "Minor Surgery Kit" },
                                        { img: img6, title: "Stainless Steel Kits" },
                                        { img: img7, title: "Stainless Steel Basins" },
                                        { img: img8, title: "Stainless Steel Bowl" },
                                        { img: img13, title: "Stainless Steel Kidney Dishes" },
                                        { img: img14, title: "Scissors" },
                                        { img: img15, title: "Scissors" },
                                        { img: img16, title: "Scissors" },
                                        { img: img17, title: "Scissors" }
                                    ].map((item, idx) => (
                                        <Col key={idx}>
                                            <Card className="h-100 text-center border-info">
                                                <Card.Img variant="top" src={item.img} />
                                                <Card.Body>
                                                    <Card.Title>{item.title}</Card.Title>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    ))}
                                </Row>
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="1">
                            <Accordion.Header>Dissection Forceps</Accordion.Header>
                            <Accordion.Body className="fondo-texto">
                                <ul>
                                    <li>Cushing Forceps</li><li>Potts – Smith Forceps</li><li>Russian Forceps</li>
                                    <li>Semken Forceps</li><li>Adson Forceps</li>
                                </ul>
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="2">
                            <Accordion.Header>Hemostatic Forceps</Accordion.Header>
                            <Accordion.Body className="fondo-texto">
                                <Row>
                                    <Col md={6}>
                                        <ul>
                                            <li>Sponge Forceps (Aro)</li><li>Backhaus Towel Clamps</li><li>Bertola Forceps</li>
                                            <li>Bozeman Forceps</li><li>Chaput Forceps</li><li>Crafoord Clamps</li>
                                            <li>Wertheim Clamps</li><li>Crile Forceps</li><li>Crile Rankin Forceps</li>
                                            <li>Dandy Scalp Forceps</li><li>Desjardin Cystic Forceps</li>
                                            <li>Doyen Forceps</li><li>Faure Uterine Artery Forceps</li>
                                            <li>Foerster Forceps</li><li>Gregoire Forceps</li><li>Guyon Forceps</li>
                                        </ul>
                                    </Col>
                                    <Col md={6}>
                                        <ul>
                                            <li>Halstead Forceps</li><li>Harringthon-Lovel Forceps</li>
                                            <li>Heaney Forceps</li><li>Heiss Forceps</li><li>Kelly-Rankin Forceps</li>
                                            <li>Kelly Forceps</li><li>Kocher Forceps</li><li>Lahey Forceps</li>
                                            <li>Maier Uterine Forceps</li><li>Martel Forceps</li><li>Mixter Forceps</li>
                                            <li>Pean Forceps</li><li>Pozzi Forceps</li><li>Rochester Pean Forceps</li>
                                            <li>Schade Forceps</li><li>Schnidt Forceps</li>
                                        </ul>
                                    </Col>
                                </Row>
                                {/* Secondary gallery */}
                                <Row xs={1} md={3} className="g-4 mt-3">
                                    {[img1, img9, img10, img11, img12].map((image, idx) => (
                                        <Col key={idx}>
                                            <Card className="h-100 text-center border-info">
                                                <Card.Img variant="top" src={image} />
                                                <Card.Body><Card.Title>Forceps</Card.Title></Card.Body>
                                            </Card>
                                        </Col>
                                    ))}
                                </Row>
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="3">
                            <Accordion.Header>Retractors</Accordion.Header>
                            <Accordion.Body className="fondo-texto">
                                <Row>
                                    <Col md={6}>
                                        <ul>
                                            <li>Balfour Retractor</li><li>Blepharostat Retractor</li><li>Caeiro Retractor</li>
                                            <li>Cushing Vein Retractor</li><li>Deaver Retractor</li><li>Farabeuf Retractor</li>
                                            <li>Finochietto Rib Spreader</li><li>Gelpi Retractor</li><li>Gosset Retractor</li>
                                            <li>Jansen Retractor</li><li>Langenbeck Retractor</li>
                                        </ul>
                                    </Col>
                                    <Col md={6}>
                                        <ul>
                                            <li>Love Nerve Retractor</li><li>Millin Retractor</li><li>Millin Wire Retractor</li>
                                            <li>Richardson Retractor</li><li>Roux Retractor</li><li>Senn-Mueller Retractor</li>
                                            <li>Weitlaner Retractor</li><li>Volkmann Retractor</li><li>Adson Retractors</li><li>Doyen Valve</li>
                                        </ul>
                                    </Col>
                                </Row>
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="4">
                            <Accordion.Header>Suture Instruments</Accordion.Header>
                            <Accordion.Body className="fondo-texto">
                                <ul>
                                    <li>Bozeman Needle Holder</li><li>DeBakey Needle Holder</li>
                                    <li>Halsey Needle Holder</li><li>Masson Needle Holder</li>
                                    <li>Ryder Needle Holder</li><li>Olsen – Hegar Needle Holder Scissors</li>
                                    <li>Finochietto Needle Holder</li><li>Hegar Needle Holder</li>
                                    <li>Mathieu Needle Holder</li><li>Mayo – Hegar Needle Holder</li>
                                </ul>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </Container>
                <Footer />
            </div>
        )
    }
}